import {
  AboutYouSVGLogo,
  ContactInfo,
  SocialLinks,
} from '@aboutyou/ui-components';
import {styled} from '@linaria/react';
import React from 'react';

export interface ContactsSectionProps {
  contactInfoEntries: React.ComponentProps<typeof ContactInfo>['entries'];
  socialLinks: React.ComponentProps<typeof SocialLinks>['entries'];
}

export const ContactsSection: React.FC<ContactsSectionProps> = ({
  contactInfoEntries,
  socialLinks,
}) => {
  return (
    <Wrapper data-testid="contactsSection">
      <StyledLogo dataTestId="footerLogo" />
      <ContactInfo entries={contactInfoEntries} />
      <SocialLinks entries={socialLinks} />
    </Wrapper>
  );
};

const Wrapper = styled.div`
  padding: 1.5rem;
  box-sizing: border-box;
`;

const StyledLogo = styled(AboutYouSVGLogo)`
  &&& {
    min-width: 60px;
    width: 150px;
    height: 32px;
    transform: scale(1.4) translateX(1.5rem);
  }
`;
